import { render } from "./AssignBridge.vue?vue&type=template&id=12199481"
import script from "./AssignBridge.vue?vue&type=script&lang=js"
export * from "./AssignBridge.vue?vue&type=script&lang=js"

import "./AssignBridge.vue?vue&type=style&index=0&id=12199481&scope=true&lang=css"

import exportComponent from "/tmp/build_ada65e43/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__